/*
 * @Author: wzh
 * @LastEditTime: 2023-01-06 14:07:29
 * @Description: 响应拦截器
 */
import config from "@/config";
import {
	AUTH_MESSAGE_KEYWORDS,
	clearAuthStateAndRedirect,
	isAuthErrorMessage,
} from "@/utils/authSession";

export const registerResponseInterceptors = (axiosInstance) => {
	axiosInstance.interceptors.response.use(validateCode);
};

function getResponseMessage(res) {
	if (!res || typeof res !== "object") {
		return "";
	}
	const msgField = config.SERVICES.RESPONSE_MESSAGE_FILED;
	return String(res[msgField] || res.msg || res.message || "");
}

function getResponseCode(res) {
	if (!res || typeof res !== "object") {
		return undefined;
	}
	const codeField = config.SERVICES.RESPONSE_CODE_FILED;
	if (res[codeField] !== undefined && res[codeField] !== null) {
		return res[codeField];
	}
	if (res.status !== undefined && res.status !== null) {
		return res.status;
	}
	return res.code;
}

function isUnauthorizedResponse(response) {
	const httpStatus = response.status;
	if (httpStatus === config.SERVICES.RESPONSE_CODE.UNAUTHORIZED) {
		return true;
	}

	const res = response.data;
	if (!res) {
		return false;
	}

	const code = getResponseCode(res);
	if (code == config.SERVICES.RESPONSE_CODE.UNAUTHORIZED) {
		return true;
	}

	const message = getResponseMessage(res);
	if (isAuthErrorMessage(message)) {
		return true;
	}

	// 非 0 业务码且文案含鉴权相关关键字
	if (
		code != null &&
		code != config.SERVICES.RESPONSE_CODE.OK &&
		AUTH_MESSAGE_KEYWORDS.some((keyword) => message.includes(keyword))
	) {
		return true;
	}

	return false;
}

/**
 * 验证响应数据的 code 是否正确
 */
function validateCode(response) {
	const res = response.data;
	if (!res) {
		if (response.status === config.SERVICES.RESPONSE_CODE.UNAUTHORIZED) {
			clearAuthStateAndRedirect();
			throw new Error("系统异常，请重新登录！");
		}
		throw new Error("请求失败");
	}

	if (isUnauthorizedResponse(response)) {
		clearAuthStateAndRedirect();
		throw new Error(getResponseMessage(res) || "系统异常，请重新登录！");
	}

	return res;
}
